import React from 'react';
import ResourceSelector from "../../../../Components/Inputs/Selects/ResourceSelector";
import ConfigFormRow from "../../../../Components/HorizontalForm/ConfigFormRow";
import CheckboxInputValueCompatible from "../../../../Components/Inputs/CheckboxInputValueCompatible";
import { defaultConfig } from "../EntityConfig";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const EntityAdditionalConfig = (props) => {

    const activeModules = useSelector(state => state.admin.global.activeModules);

    const moduleConfig = useSelector(state => state.admin.global.moduleConfigs['BOOKINGS']);

    const isOverride = () => {
        return (props.parentConfig) ? true : false;
    }

    const getParentValue = (field) => {
        if (props.parentConfig && props.parentConfig.hasOwnProperty(field)) {
            return props.parentConfig[field];
        }
        if (defaultConfig[field]) {
            return defaultConfig[field]
        }
        return null;
    }

    return (<>
        {moduleConfig.enableSignIn && (
            <ConfigFormRow
                isOverride={isOverride()}
                label="Sign In/Out"
                errorMessage={props.errors.sign_in_enabled}
                leftCellClassName="small-9"
                rightCellClassName="small-3 text-right"
                className="margin-bottom-0"

                name="sign_in_enabled"
                value={props.config.sign_in_enabled}
                parentValue={getParentValue('sign_in_enabled')}
                onChange={props.onChange}
            >
                <CheckboxInputValueCompatible/>
            </ConfigFormRow>
        )}

        { ( props.config.sign_in_enabled
            || (props.config.sign_in_enabled === null && getParentValue('sign_in_enabled'))
            && moduleConfig.enableSignIn
        ) && (
            <div className="padding-left-1">
                <ConfigFormRow
                    isOverride={isOverride()}
                    label="Searched On Arrival"
                    errorMessage={props.errors.searched_at_sign_in_enabled}
                    leftCellClassName="small-9"
                    rightCellClassName="small-3 text-right"
                    className="margin-bottom-0"

                    name="searched_at_sign_in_enabled"
                    value={props.config.searched_at_sign_in_enabled}
                    parentValue={getParentValue('searched_at_sign_in_enabled')}
                    onChange={props.onChange}
                >
                    <CheckboxInputValueCompatible/>
                </ConfigFormRow>
            </div>
        )}


        <ConfigFormRow
            isOverride={isOverride()}
            label="Custom Form"
            leftCellClassName="small-9"
            rightCellClassName="small-3 text-right"
            className="margin-bottom-0"

            name="custom_form_enabled"
            value={props.config.custom_form_enabled}
            parentValue={getParentValue('custom_form_enabled')}
            onChange={props.onChange}
        >
            <CheckboxInputValueCompatible/>
        </ConfigFormRow>

        { (props.config.custom_form_enabled) &&
            <div className="padding-left-1">
                <ConfigFormRow
                    isOverride={isOverride()}
                    label="Custom form type"
                    errorMessage={props.errors.custom_form}
                    cellClassName="large-7"
                    name="custom_form"
                    value={props.config.custom_form}
                    parentValue={getParentValue('custom_form')}
                    onChange={props.onChange}
                >
                    <ResourceSelector
                        module="admin"
                        type="custom-forms"
                        placeholder="None"
                    />
                </ConfigFormRow>
            </div>
        }

        { (activeModules && activeModules.includes('VISITORS')) && (<>
            <ConfigFormRow
                isOverride={isOverride()}
                label="Add Visitor(s)"
                errorMessage={props.errors.visitors_enabled}
                leftCellClassName="small-9"
                rightCellClassName="small-3 text-right"
                className="margin-bottom-0"

                name="visitors_enabled"
                value={props.config.visitors_enabled}
                parentValue={getParentValue('visitors_enabled')}
                onChange={props.onChange}
            >
                <CheckboxInputValueCompatible/>
            </ConfigFormRow>

            { ( props.config.visitors_enabled
                || (props.config.visitors_enabled === null && getParentValue('visitors_enabled'))
            ) && (
                <div className="padding-left-1">
                    <ConfigFormRow
                        isOverride={isOverride()}
                        label="Visitor Type"
                        errorMessage={props.errors.visitors_type}
                        cellClassName="large-7"

                        name="visitors_type"
                        value={props.config.visitors_type}
                        parentValue={getParentValue('visitors_type')}
                        onChange={props.onChange}
                    >
                        <ResourceSelector
                            module="admin"
                            type="visitor-types"
                        />
                    </ConfigFormRow>

                    <ConfigFormRow
                        isOverride={isOverride()}
                        label="Entrance Selection"
                        errorMessage={props.errors.visitors_entrance}
                        cellClassName="large-7"

                        name="visitors_entrance"
                        value={props.config.visitors_entrance}
                        parentValue={getParentValue('visitors_entrance')}
                        onChange={props.onChange}
                    >
                        <ResourceSelector
                            module="admin"
                            type="visitor-entrances"
                        />
                    </ConfigFormRow>
                </div>
            )}
        </>)}

    </>)
}

EntityAdditionalConfig.propTypes = {
    onChange: PropTypes.func.isRequired,
}

export default EntityAdditionalConfig;
